import { Button, Skeleton, Space, Typography } from "antd"
import { PageHeaderSection } from "../../components/common/PageHeadSection"
import { t } from "i18next"
import { useQuery } from "react-query"
import { PmsIntegrationsService } from "../../services/PmsIntegrationsService"
import { PmsIntegrationsTable } from "../../components/pmsIntegrations/PmsIntegrationsTable"
import { InfoCircleOutlined } from '@ant-design/icons';
import { SFModal } from "../../components/elements/SFModal"
import { useState } from "react"
import { GetInformation } from "../../components/pmsIntegrations/GetInformation"
import $ from 'jquery';

export const PmsIntegrations = () => {
    const [openGetInformationModal, setOpenGetInformationModal] = useState<boolean>(false);

    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getPmsIntegrations"],
        () => (PmsIntegrationsService.List({})),
        {
            refetchOnWindowFocus: false,
            enabled: true
        }
    )

    const handleGetInformationClick = () => {
        setOpenGetInformationModal(true);
    }

    const closeModal = () => {
        setOpenGetInformationModal(false);
    }

    return (
        <>
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("pmsIntegrations.title")}
                            />
                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                {
                                                    <Space size="small" direction="vertical">
                                                        <b>{t("pmsIntegrations.description")}</b>
                                                        <Button size="middle" type="primary" icon={<InfoCircleOutlined />} onClick={handleGetInformationClick}>{t("pmsIntegrations.getInformation")}</Button>
                                                    </Space>
                                                }
                                                {
                                                    isLoading
                                                    &&
                                                    <>
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                    </>
                                                }
                                                {
                                                    data
                                                    &&
                                                    <PmsIntegrationsTable
                                                        dataSource={data?.body?.data}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SFModal
                width={window.innerWidth * 34 / 100}
                open={openGetInformationModal}
                toggler={() => setOpenGetInformationModal(!openGetInformationModal)}
                body={<GetInformation fnCloseModal={closeModal} />}
                title={t("pmsIntegrations.getInformation")}
            />
        </>
    )
}
